import Layout from '@/layout'

const FinanceManageRouter = {
  path: '/FinanceManage',
  component: Layout,
  redirect: 'noredirect',
  name: 'Finance',
  meta: {
    title: '财务管理',
    icon: 'daohang-ziliaoguanli'
    // roles: ['subsystem']
  },
  children: [
    {
      path: 'FinanceInterface',
      component: () => import('@/views/cargo/v0/FinanceManage/FinanceInterface'),
      name: 'FinanceInterface',
      meta: { title: '初始设置' },
      props: true,
      roles: []
    },
    {
      path: 'VoucherMaintenance',
      component: () => import('@/views/cargo/v0/FinanceManage/VoucherMaintenance'),
      name: 'VoucherMaintenance',
      meta: { title: '生成凭证' },
      props: true,
      roles: []
    },
    {
      path: 'AccountingDocument',
      component: () => import('@/views/cargo/v0/FinanceManage/AccountingDocument'),
      name: 'AccountingDocument',
      meta: { title: '凭证录入' },
      props: true,
      roles: []
    },
    {
      path: 'AccountingDocumentSearch',
      component: () => import('@/views/cargo/v0/FinanceManage/AccountingDocumentSearch'),
      name: 'AccountingDocumentSearch',
      meta: { title: '查凭证' },
      props: true,
      roles: []
    },
    {
      path: 'AccountBook',
      component: () => import('@/views/cargo/v0/FinanceManage/AccountBook'),
      name: 'AccountBook',
      meta: { title: '账簿新版' },
      props: true,
      roles: []
    },
    {
      path: 'AccountingClosing',
      component: () => import('@/views/cargo/v0/FinanceManage/AccountingClosing'),
      name: 'AccountingClosing',
      meta: { title: '结账新版' },
      props: true,
      roles: []
    },
    {
      path: 'FinancialReport',
      component: () => import('@/views/cargo/v0/FinanceManage/FinancialReport'),
      name: 'FinancialReport',
      meta: { title: '报表新版' },
      props: true,
      roles: []
    },
    {
      path: 'BusinessCommissionModule',
      component: () => import('@/views/cargo/v0/FinanceManage/BusinessCommissionModule'),
      name: 'BusinessCommissionModule',
      meta: { title: '业务提成' },
      roles: ['module_BusinessCommissionModule']
    },
    {
      path: 'NegativeProfitOrder',
      component: () => import('@/views/cargo/v0/FinanceManage/NegativeProfitOrder'),
      name: 'NegativeProfitOrder',
      meta: { title: '财务待办列表' },
      props: true,
      roles: []
    },
    {
      path: 'UsaReport',
      component: () => import('@/views/cargo/v0/FinanceManage/UsaReport'),
      name: 'UsaReport',
      meta: { title: 'USA Report' },
      props: true,
      roles: []
    }
  ]
}

export default FinanceManageRouter
